// @flow
import * as React from 'react';
import styles from './Fieldset.scss';

type LegendProps = {
  legend: ?string,
  Icon?: () => React.Element<any>,
};

const FieldsetLegend = ({ legend, Icon }: LegendProps) => (
  <div className={styles.fieldsetLegend}>
    {Icon && (
      <div className={styles.fieldsetLegendIcon}>
        <Icon />
      </div>
    )}
    <h3 className={styles.fieldsetLegendHeading}>{legend}</h3>
  </div>
);

type Props = LegendProps & {
  children?: Array<React.Element<any>>,
};
const Fieldset = (props: Props) => {
  const { legend, Icon, children } = props;

  return (
    <fieldset className={styles.fieldset}>
      {legend && <FieldsetLegend legend={legend} Icon={Icon} />}
      <div className={styles.fieldsetContent}>{children}</div>
    </fieldset>
  );
};

Fieldset.Legend = FieldsetLegend;

export default Fieldset;



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/Fieldset.js